import type { LayoutProps } from "@/features/companyDetail/types"
import type { PagesRouterPage } from "@/types"
import type { PropsWithChildren } from "react"

import { Layout as RubiksLayout, LAYOUT_COLOR_BLOCK } from "@jobteaser/ui-kit/components/Layout/Layout"

import { Breadcrumbs } from "@/features/companyDetail/components/Layout/Breadcrumbs/Breadcrumbs"
import { Header } from "@/features/companyDetail/components/Layout/Header/Header"
import { Menu } from "@/features/companyDetail/components/Layout/Menu/Menu"
import { CCTheme } from "@/modules/careerCenter/components/CCTheme"
import { useCompanyFetch } from "@/modules/companies/hooks/useCompanyFetch"
import { FoLayout } from "@/modules/layouts/components/FoLayout"

export const Layout: PagesRouterPage<PropsWithChildren<LayoutProps>> = props => {
  const { children, host, serverContext } = props
  const { baseUrl } = serverContext || { baseUrl: "" }
  const { dataCompany } = useCompanyFetch()

  if (dataCompany) {
    return (
      <CCTheme>
        <FoLayout host={host}>
          <RubiksLayout colorBlock={LAYOUT_COLOR_BLOCK.WHITE} hasBottomPadding hasTopPadding>
            <RubiksLayout.Column>
              <Header baseUrl={baseUrl} />
            </RubiksLayout.Column>
          </RubiksLayout>
          <RubiksLayout colorBlock={LAYOUT_COLOR_BLOCK.WHITE} hasBottomPadding>
            <RubiksLayout.Column>
              <Menu />
            </RubiksLayout.Column>
          </RubiksLayout>
          {children}
          <RubiksLayout colorBlock={LAYOUT_COLOR_BLOCK.WHITE} hasBottomPadding hasTopPadding>
            <RubiksLayout.Column>
              <Breadcrumbs />
            </RubiksLayout.Column>
          </RubiksLayout>
        </FoLayout>
      </CCTheme>
    )
  }

  return null
}
